import type { BuilderMode } from '../../types/guided-builder';

interface GuidedModeToggleProps {
  mode: BuilderMode;
  onModeChange: (mode: BuilderMode) => void;
}

export function GuidedModeToggle({ mode, onModeChange }: GuidedModeToggleProps) {
  return (
    <div className="inline-flex items-center rounded-md border bg-muted p-0.5 text-xs">
      <button
        onClick={() => onModeChange('guided')}
        className={`px-2 py-0.5 rounded-sm transition-colors ${
          mode === 'guided'
            ? 'bg-background text-foreground shadow-sm font-medium'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        Guided
      </button>
      <button
        onClick={() => onModeChange('chat')}
        className={`px-2 py-0.5 rounded-sm transition-colors ${
          mode === 'chat'
            ? 'bg-background text-foreground shadow-sm font-medium'
            : 'text-muted-foreground hover:text-foreground'
        }`}
      >
        Chat
      </button>
    </div>
  );
}
